import * as types from "../actions/types/index";
import {setInitialState} from "../util/utility";

const INITIAL_STATE = setInitialState({
    geoip: null,
});

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.GEOIP_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.GEOIP_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload
            };
        case types.GEOIP_RESET:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}